import { useEffect, useRef, useState } from "react";
import sampleimg from "../../../assets/sample-blog-img.jpg";
import "./BrandingDetails.css";
import Header from "../../Header";
import PageTransition from "../../../PageTransition";
const IMAGES = [sampleimg, sampleimg, sampleimg, sampleimg];

export default function KumudBranding() {
  const [index, setIndex] = useState(0);
  const railRef = useRef(null);
  const isAnimating = useRef(false);
  const startX = useRef(0);
  const touchStartX = useRef(0);

  const isMobile = window.innerWidth <= 768;

  const slideTo = (next) => {
    if (next < 0 || next >= IMAGES.length) return;
    isAnimating.current = true;
    setIndex(next);
    setTimeout(() => (isAnimating.current = false), 700);
  };

  /* ================= WHEEL (DESKTOP ONLY) ================= */
  useEffect(() => {
    if (isMobile) return;

    const onWheel = (e) => {
      e.preventDefault();
      if (isAnimating.current) return;
      if (e.deltaY > 0) slideTo(index + 1);
      if (e.deltaY < 0) slideTo(index - 1);
    };

    window.addEventListener("wheel", onWheel, { passive: false });
    return () => window.removeEventListener("wheel", onWheel);
  }, [index, isMobile]);

  /* ================= DRAG ================= */
  const onMouseDown = (e) => {
    startX.current = e.clientX;
  };

  const onMouseUp = (e) => {
    if (isAnimating.current) return;
    const delta = e.clientX - startX.current;
    if (delta > 80) slideTo(index - 1);
    if (delta < -80) slideTo(index + 1);
  };

  /* ================= TOUCH ================= */
  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) < 60) return;
    if (delta < 0) slideTo(index + 1);
    if (delta > 0) slideTo(index - 1);
  };

  /* ================= PIXEL TRANSLATE ================= */
  const getTranslateX = () => {
    if (!railRef.current) return 0;
    const card = railRef.current.querySelector(".branding-detail-card");
    if (!card) return 0;

    const gap = window.innerWidth <= 768 ? 16 : 42;
    return index * (card.offsetWidth + gap);
  };

  return (
    <>
      <Header visible mode="normal" />
        <PageTransition>

      <main className="branding-detail-page">
        {/* HERO */}
        <section className="branding-detail-hero">
          <h1>KUMUD BRANDING</h1>
          <p>
            Lorem ipsum Crazy Branding Stuff And Astrofuh Argato Gozaimatsu Falana
            Falana
          </p>
        </section>

        {/* SLIDER */}
        <section
          className="branding-detail-rail"
          ref={railRef}
          onMouseDown={!isMobile ? onMouseDown : undefined}
          onMouseUp={!isMobile ? onMouseUp : undefined}
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <div
            className="branding-detail-track"
            style={{ transform: `translateX(-${getTranslateX()}px)` }}
          >
            {IMAGES.map((img, i) => (
              <div className="branding-detail-card" key={i}>
                <div
                  className="branding-detail-image"
                  style={{ backgroundImage: `url(${img})` }}
                />
              </div>
            ))}
          </div>

          <div className="branding-detail-shadow" />
        </section>

        {/* FIXED CONTENT */}
        <div className="branding-detail-footer">
          Lorem ipsum Crazy Branding Stuff And Astrofuh Argato Gozaimatsu Falana
          Falana
        </div>
      </main>
      </PageTransition>
    </>
  );
}
